import { useQuery } from '@tanstack/react-query'
import { zetApi } from '@zet/network'

import { CreditBureauExperimentName } from '../../constants'
import { ICreditBureauExperimentResponse } from '../types'

async function getCreditBureauExperiment(
  experimentName: CreditBureauExperimentName
) {
  const { data } = await zetApi.get<ICreditBureauExperimentResponse>(
    `experiment/evaluate?experimentName=${experimentName}`
  )
  return data?.data
}

function useGetCreditBureauExperiment(
  experimentName: CreditBureauExperimentName
) {
  return useQuery(
    ['getCreditBureauExperiment'],
    () => getCreditBureauExperiment(experimentName),
    {
      refetchOnWindowFocus: false,
    }
  )
}

export { useGetCreditBureauExperiment }
